var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.661 25.286C15.869 25.286 15.1136 25.1283 14.395 24.813C13.6763 24.4903 13.0493 24.0393 12.514 23.46C11.986 22.8807 11.6083 22.1987 11.381 21.414L14.285 20.644C14.439 21.2233 14.7396 21.6743 15.187 21.997C15.6416 22.3123 16.133 22.47 16.661 22.47C17.1156 22.47 17.53 22.36 17.904 22.14C18.2853 21.92 18.586 21.623 18.806 21.249C19.0333 20.875 19.147 20.4607 19.147 20.006C19.147 19.324 18.9123 18.741 18.443 18.257C17.981 17.7657 17.387 17.52 16.661 17.52C16.441 17.52 16.2283 17.553 16.023 17.619C15.8176 17.6777 15.6196 17.762 15.429 17.872L14.087 15.518L19.125 11.338L19.345 11.976H11.997V9.16H21.897V11.976L17.981 15.76L17.959 14.924C18.8683 15.0633 19.6346 15.3823 20.258 15.881C20.8886 16.3723 21.3653 16.981 21.688 17.707C22.018 18.4257 22.183 19.192 22.183 20.006C22.183 21.0033 21.93 21.9017 21.424 22.701C20.918 23.493 20.247 24.1237 19.411 24.593C18.575 25.055 17.6583 25.286 16.661 25.286Z",
    fill: "#EB3000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 34.0033C14.534 29.7134 8.25 31.392 8.25 35.6074C8.25 40.3449 14.7727 42.0236 16.9601 46.4254L16.9999 46.5L17.0397 46.4254C19.2272 42.0236 25.7498 40.3449 25.7498 35.6074C25.7896 31.392 19.4658 29.7134 16.9999 34.0033Z",
    fill: "#EB3000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9998 50.0059C32.5612 42.2841 21.25 45.3057 21.25 52.8932C21.25 61.4208 32.9908 64.4424 36.9282 72.3657L36.9998 72.5L37.0714 72.3657C41.0089 64.4424 52.7497 61.4208 52.7497 52.8932C52.8213 45.3057 41.4384 42.2841 36.9998 50.0059Z",
    fill: "#EB3000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3H);
export default __webpack_public_path__ + "static/media/3h.cb95f7be0e918bfa24ac4bfab6821f53.svg";
export { ForwardRef as ReactComponent };